import React from "react";
import { CGE } from "../../../../common/components/CGE";
import Pagination from "../../../../common/components/Pagination";
import { getPathName } from "../../../../common/utils/utilsFunc";
import AssociatedClientsContextProvider, {
  AssociatedClientsContext,
  ACTIONS,
} from "../../context/AssociatedClientsContextProvider";
import AssociatedClientsTable from "../AssociatedClientsTable";
import arTitles from "../../../../common/services/mock/title.json";
import HeaderSearch from "../../../../common/components/HeaderSearch";
import Loading from "../../../../common/components/Loading";
import AlertModal from "../../../../common/components/AlertModal";
import { useModal } from "@clayui/modal";
import ModalContentEdit from "../ModalContentEdit";

function AssociatedClientsController({ props }) {
  const [activePage, setActivePage] = React.useState(1);
  const [dataTable, setDataTable] = React.useState([]);
  const [idList, setIdList] = React.useState([]);
  const [inputSearch, setInputSearch] = React.useState("");
  const [inputSelected, setInputSelected] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [rowPage, setRowPageList] = React.useState(10);
  const [state, dispatch] = React.useContext(AssociatedClientsContext);
  const [currentArray, setCurrentArray] = React.useState([]);
  const [auxArray, setAuxArray] = React.useState([]);
  const [newArrTitle, setNewArrTitle] = React.useState(null);
  const [findOne, setFindOne] = React.useState(false);

  const [visibleModalConfirm, setVisibleModalConfirm] = React.useState(false);
  const [typeFuncConfirm, setTypeFuncConfirm] = React.useState(0);
  const [alertMsg, setAlertMsg] = React.useState("");
  const { observer, onClose } = useModal({
    onClose: () => {
      setVisibleModalConfirm(false);
      setTypeFuncConfirm(0);
      setAlertMsg();
    },
  });
  const [form, setForm] = React.useState();
  const [validForm, setValidForm] = React.useState({});
  const [dataCurrentClient, setDataCurrentClient] = React.useState({});

  React.useEffect(() => {
    setNewArrTitle(arTitles[getPathName()]?.map((item) => item.label));
    setLoading(true);
  }, [getPathName()]);

  function setRowPage(nPage) {
    setActivePage(1);
    setRowPageList(Number(nPage));
  }

  function handleClickButtonModification(obj) {
    setTypeFuncConfirm(1);
    setVisibleModalConfirm(true);
    setDataCurrentClient(obj);
    setForm({ ...form, name: obj?.NOMBRE_CTA, id: obj?.CTA_CTO });
  }

  function handleClickButtonModificationConfirm() {
    setTimeout(() => {
      setTypeFuncConfirm(2);
      setAlertMsg("¿Confirmar la edición?");
      setVisibleModalConfirm(true);
    }, 300);
  }

  function handleClickButtonAnulation(obj) {
    setDataCurrentClient(obj);
    setTypeFuncConfirm(3);
    setAlertMsg("¿Confirmar la eliminación?");
    setVisibleModalConfirm(true);
  }

  function handleDeleteAllClients() {
    setTypeFuncConfirm(4);
    setAlertMsg("¿Confirmar la eliminación de todos?");
    setVisibleModalConfirm(true);
  }

  function handleAddClient() {
    window.open(`/group/guest/agregar-cliente-asociado`, "_self");
  }

  function funcConfirm() {
    switch (typeFuncConfirm) {
      case 1:
        handleClickEdit();
        break;
      case 2:
        setLoading(true);
        dispatch({
          type: ACTIONS.SET_FORM,
          payload: form,
        });
        setVisibleModalConfirm(false);
        setTypeFuncConfirm(0);
        setAlertMsg();
        break;
      case 3:
        setLoading(true);
        dispatch({
          type: ACTIONS.SET_DELETE_ID,
          payload: dataCurrentClient.CTA_CTO,
        });
        setVisibleModalConfirm(false);
        setTypeFuncConfirm(0);
        setAlertMsg();
        break;
      case 4:
        setLoading(true);
        const auxArrayId = [];

        auxArray.forEach((obj) => {
          auxArrayId.push(obj.CTA_CTO);
        });
        dispatch({
          type: ACTIONS.SET_DELETE_ID,
          payload: auxArrayId,
        });
        setVisibleModalConfirm(false);
        setTypeFuncConfirm(0);
        setAlertMsg();
        break;
      case 5:
        document.location.reload(true);
        break;
    }
  }

  function validFormModal() {
    let validFormAux = {};

    if (!form?.name) {
      validFormAux.validateName = true;
      validFormAux.msgName = "Debes ingresar el Nombre";
      props.setGlobalAlert("Complete todos los campos obligatorios.", "warning");
    }
    setValidForm(validFormAux);
    return validFormAux;
  }

  function handleClickEdit() {
    const validForm = validFormModal();
    if (Object.keys(validForm)?.length === 0) {
      handleClickButtonModificationConfirm();
    }
  }

  React.useEffect(() => {
    if (state.deleteResponse) {
      setLoading(false);

      const objResponse = state.deleteResponse;

      if (objResponse?.response?.status === 200 || objResponse?.data?.status === 200) {
        setTypeFuncConfirm(5);
        setAlertMsg(
          objResponse?.data?.out ? objResponse?.data?.out : "¡Relaciones eliminadas con éxito!"
        );
        setVisibleModalConfirm(true);
      } else {
        props.setGlobalAlert(
          "El servicio no está disponible actualmente, intente más tarde.",
          "warning",
          true,
          "Advertencia"
        );
      }
    }
  }, [state.deleteResponse]);

  React.useEffect(() => {
    if (state.formResponse) {
      setLoading(false);
      const objResponse = state.formResponse;
      if (objResponse?.response?.ok) {
        setTypeFuncConfirm(5);
        setAlertMsg("¡Modificación exitosa!");
        setVisibleModalConfirm(true);
      } else {
        props.setGlobalAlert(
          "El servicio no está disponible actualmente, intente más tarde.",
          "warning",
          true,
          "Advertencia"
        );
      }
    }
  }, [state.formResponse]);

  React.useEffect(() => {
    if (inputSearch) {
      if (idList.find((idList) => idList.toString() === inputSearch)) {
        setInputSelected(inputSearch);
        document.getElementById("mySelectId").value = inputSearch;
      } else {
        setInputSelected("");
        document.getElementById("mySelectId").value = "";
      }
    }
  }, [inputSearch]);

  React.useEffect(() => {
    if (inputSelected) {
      setInputSearch("");
    }
  }, [inputSelected]);

  React.useEffect(() => {
    if (state.idList) {
      let data = state.idList;
      if (data.length > 0) {
        setLoading(true);
        setIdList(data);
        window.scrollTo({ top: 0, behavior: "smooth" });

        setInputSelected("");
        document.getElementById("mySelectId").value = "";

        dispatch({
          payload: { idClient: data, numPage: activePage, quantItems: rowPage },
          type: ACTIONS.SET_IDCLIENT,
        });
      } else {
        setIdList([]);
        dispatch({
          payload: null,
          type: ACTIONS.SET_IDCLIENT,
        });
      }
    }
  }, [state.idList, rowPage, activePage]);

  React.useEffect(() => {
    const objCb = state.currentBalance;
    setLoading(false);
    if (objCb.ConsultarListaEstadoServiciosResponse?.RETORNO?.RETURN === 0) {
      let newListCurrent = JSON.parse(
        JSON.stringify(objCb.ConsultarListaEstadoServiciosResponse?.ITEM)
      );
      newListCurrent = [
        ...newListCurrent,
        newListCurrent.map((obj) => {
          obj.opciones = "opciones";
        }),
      ];
      newListCurrent.splice(newListCurrent.length - 1, 1);
      setDataTable(newListCurrent);
    } else if (objCb.ConsultarListaEstadoServiciosResponse?.RETORNO?.RETURN === 1) {
      props.setGlobalAlert(
        objCb.ConsultarListaEstadoServiciosResponse.RETORNO.TEXTO_RETURN,
        "warning",
        true,
        "Advertencia"
      );
    }
    if (state.currentBalance.status) {
      props.setGlobalAlert(props.text_fetch_error, "warning", true, "Advertencia");
    }
  }, [state.currentBalance]);

  React.useEffect(() => {
    let filterArray = [];
    setAuxArray(dataTable);

    if (inputSelected) {
      filterArray = dataTable.filter(function (obj) {
        return obj.CTA_CTO.toString() === inputSelected;
      });
      if (filterArray?.length > 0) {
        setAuxArray(filterArray);
      } else {
        setLoading(true);
        dispatch({
          payload: { idClient: [inputSelected], numPage: 1, quantItems: 1 },
          type: ACTIONS.SET_IDCLIENT,
        });
      }
      setFindOne(true);
    } else if (!inputSelected && findOne) {
      setFindOne(false);
      setLoading(true);
      dispatch({
        payload: {
          idClient: state?.idList ? state.idList : [],
          numPage: activePage,
          quantItems: rowPage,
        },
        type: ACTIONS.SET_IDCLIENT,
      });
    }

    if (!inputSelected && !inputSearch) {
      setCurrentArray(dataTable?.sort((a, b) => a.CTA_CTO - b.CTA_CTO));
    } else if (dataTable?.length === 0) {
      props.setGlobalAlert(props.text_fetch_error, "warning", true, "Advertencia");
      setLoading(false);
    } else {
      setCurrentArray(filterArray?.sort((a, b) => a.CTA_CTO - b.CTA_CTO));
    }
  }, [inputSelected, dataTable, activePage]);

  React.useEffect(() => {
    if (state.errorFetch) {
      props.setGlobalAlert(props.text_fetch_error, "warning", true, "Advertencia");
      setLoading(false);
    }
  }, [state.errorFetch]);

  var panelFooter = (
    <>
      {auxArray?.length > 0 && (
        <div className="d-flex align-items-center justify-content-center flex-column-reverse pb-4">
          <Pagination
            items={auxArray?.length === 1 ? auxArray : idList}
            onChangePage={setActivePage}
            qtdRowPage={props.arQtdRowPage}
            setRowPage={setRowPage}
            pageSize={rowPage}
            currentPg={activePage}
          />
        </div>
      )}
    </>
  );

  let panelActions = (
    <>
      <CGE.InlineRow>
        <CGE.InlineCol>
          <CGE.Button type="primary" size="sm" label="Agregar" onClick={() => handleAddClient()} />
        </CGE.InlineCol>
        <CGE.InlineCol>
          <CGE.Button
            type="secondary"
            size="sm"
            label="Eliminar Todos"
            onClick={() => handleDeleteAllClients()}
          />
        </CGE.InlineCol>
      </CGE.InlineRow>
    </>
  );

  return (
    <>
      <HeaderSearch
        data={idList}
        setSearch={setInputSearch}
        setSelected={setInputSelected}
        idClient={inputSelected}
        inputSearch={inputSearch}
      />
      <CGE.Panel
        title={props.title_page_number_associated_customers}
        description={props.description_page_associated_customers}
        footerContent={panelFooter}
        topContent={panelActions}
      >
        {auxArray?.length > 0 && (
          <AssociatedClientsTable
            props={{
              ...props,
              currentArray,
              newArrTitle,
              handleClickButtonAnulation,
              handleClickButtonModification,
            }}
          />
        )}
        {loading && <Loading />}
      </CGE.Panel>
      {visibleModalConfirm && !loading && (
        <AlertModal
          titleModal={
            typeFuncConfirm === 1 ? "Oficina Virtual - Editar N° de Cliente" : "Confirmación"
          }
          observer={observer}
          onClose={onClose}
          msgModal={alertMsg}
          status={typeFuncConfirm === 5 ? "success" : "info"}
          funcClick={() => {
            funcConfirm();
          }}
          confirm={true}
          btnCancel={typeFuncConfirm === 5 ? false : true}
          labelBtnConfirm={typeFuncConfirm === 5 ? "Ok" : "Aceptar"}
        >
          {typeFuncConfirm === 1 && (
            <ModalContentEdit
              setForm={setForm}
              form={form}
              validForm={validForm}
              obj={dataCurrentClient}
            />
          )}
        </AlertModal>
      )}
    </>
  );
}
const AssociatedClientsControllerWithProvider = ({ props }) => (
  <AssociatedClientsContextProvider>
    <AssociatedClientsController props={props} />
  </AssociatedClientsContextProvider>
);
export default AssociatedClientsControllerWithProvider;
